import Streamer from "./streamer";
import socketConfig from "@frameworks/web/config/socketConfig";
import QuoteStreamRepo from "@adapters/repositories/stream/QuoteStreamRepo";
import NewsStreamRepo from "@adapters/repositories/liveNewsStream/NewsStreamRepo";
import AdvDecStreamRepo from "@adapters/repositories/advanceDeclineStream/StreamRepo";
import MarketDepthStreamRepo from "@adapters/repositories/MarketDepthStream/Quote2StreamRepo";
export var isSharedWorkerSupported = typeof SharedWorker !== "undefined";
export var streamer = Streamer();
if (isSharedWorkerSupported) {
    streamer.stream.port.postMessage({
        type: "connect",
        url: socketConfig.socketURL,
        port: socketConfig.port,
    });
}
export var qouteStream = new QuoteStreamRepo(streamer.stream, isSharedWorkerSupported);
export var newsStream = new NewsStreamRepo(streamer.stream, isSharedWorkerSupported);
export var advDecStream = new AdvDecStreamRepo(streamer.stream, isSharedWorkerSupported);
export var marketDepthStream = new MarketDepthStreamRepo(streamer.stream, isSharedWorkerSupported);
